export const INQUIRY_LOGIN_EXPERIENCE = 'INQUIRY_LOGIN_EXPERIENCE';
export const LOGIN_EXPERIENCE = 'LOGIN_EXPERIENCE';
export const HOUSE_RULES = 'HOUSE_RULES';
export const HOUSE_RULES_V2 = 'HOUSE_RULES_V2';
